import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '@coreGuards/role.guard';
import { COMPANY_PERMISSION_READ } from '@permissions/company.permissions';
import { ELD_PERMISSION_READ } from '@permissions/eld.permissions';
import { FLEET_MANAGER } from '@permissions/fleet-manager.permissions';
import { ADMIN_PERMISSION_READ } from '@permissions/super-admin.permissions';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/login',
  },
  {
    path: 'auth',
    loadChildren: () => import('@auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('@admin/admin.module').then((m) => m.AdminModule),
    canActivate: [RoleGuard],
    data: {
      roles: [
        ELD_PERMISSION_READ,
        COMPANY_PERMISSION_READ,
        ADMIN_PERMISSION_READ,
      ],
    },
  },
  {
    path: 'manager',
    loadChildren: () =>
      import('@manager/manager.module').then((m) => m.ManagerModule),
    canActivate: [RoleGuard],
    data: { roles: [FLEET_MANAGER] },
  },
  {
    path: 'live-share',
    loadChildren: () =>
      import('@liveShare/live-share.module').then((m) => m.LiveShareModule),
  },
  {
    path: 'rate-driver',
    loadChildren: () =>
      import('@rateDriver/rateDriverPage.module').then(
        (m) => m.RateDriverPageModule,
      ),
  },
  {
    path: 'whats-new',
    loadChildren: () =>
      import('@whatsNewPage/whatsNewPage.module').then(
        (m) => m.WhatsNewPageModule,
      ),
  },
  {
    path: 'availabletrucks/:companyId',
    loadChildren: () =>
      import('@shareAvailableTruck/share-available-truck.module').then(
        (m) => m.ShareAvailableTruckModule,
      ),
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
